module.exports = __webpack_public_path__ + "img/avataaars (2).a358f7d2.svg";